(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /**
         * looks for the author on the page and sets it to eVar55 and prop24
         * @param trackingObject
         */

        //remove reliance on Query
        //var authorName = jQuery('.article-author > a').text();
        var authorName = document.querySelectorAll('.article-author > a')[0];

        if (typeof(authorName) != "undefined") {

            var authorNameValue = authorName.innerHTML;
            var marketNewsArticleBodyClass = "node-type-market-news-article";
            var marketNewsArticleBodyElement = document.body;

            if (authorName && authorNameValue.length > 0 && marketNewsArticleBodyElement.classList.contains(marketNewsArticleBodyClass)) {
                //prop 44 created for nadex to record authors
                analytics.sitecatalyst.prop44 = authorNameValue;
                console.log("nadex analytics: author found", authorNameValue);
            }

        }

    });
})(window.nadex.marketing.analytics);